import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const TYPES = ["all", "oem", "ean", "name", "vehicle"];

export function SearchBar({ variant = "hero" }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [type, setType] = useState("all");
  const [q, setQ] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q.trim()) params.set("q", q.trim());
    if (type !== "all") params.set("type", type);
    navigate(`/search?${params.toString()}`);
  };

  const typeLabels = {
    all: t("hero.search.name"), oem: t("hero.search.oem"), ean: t("hero.search.ean"),
    name: t("hero.search.name"), vehicle: t("hero.search.vehicle"),
  };

  return (
    <div className={variant === "hero" ? "rounded-2xl border border-border bg-white p-3 shadow-sm sm:p-4" : ""}>
      <div className="mb-3 flex flex-wrap gap-1.5">
        {TYPES.map((ty) => (
          <button
            key={ty}
            type="button"
            data-testid={`search-type-${ty}`}
            onClick={() => setType(ty)}
            className={`rounded-full px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wide transition-colors duration-200 ${
              type === ty ? "bg-primary text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
            }`}
          >
            {ty === "all" ? t("search.all").replace(" categories", "").replace(" kategórie", "") : typeLabels[ty]}
          </button>
        ))}
      </div>
      <form onSubmit={submit} className="flex flex-col gap-2 sm:flex-row">
        <div className="flex flex-1 items-center gap-3 rounded-xl border border-border bg-slate-50 px-4 py-3">
          <Search className="h-5 w-5 shrink-0 text-slate-400" />
          <input
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={t("hero.search.placeholder")}
            className="w-full bg-transparent text-base text-slate-900 outline-none placeholder:text-slate-400"
          />
        </div>
        <button
          type="submit"
          data-testid="search-submit-button"
          className="rounded-xl bg-primary px-7 py-3 font-heading text-base font-semibold text-white transition-colors duration-200 hover:bg-blue-600"
        >
          {t("hero.search.button")}
        </button>
      </form>
    </div>
  );
}
